function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { editingMode } from 'sdc-cms-writing';
import { fieldValue } from 'sdc-data-models';

var FieldView = inject('editingStore', 'indexStore')(observer(function (_ref) {
  var store = _ref.editingStore,
      indexStore = _ref.indexStore,
      ignoreIndex = _ref.ignoreIndex,
      field = _ref.field,
      props = _objectWithoutProperties(_ref, ['editingStore', 'indexStore', 'ignoreIndex', 'field']);

  if (editingMode.isEditMode.get() && field.editable) return null;
  if ((field.dataType || 'text') !== 'text') return null;
  if ((field.display || 'single') !== 'single') return null;
  var text = fieldValue(store.selected, field.key);
  if (!text) return null;

  if (ignoreIndex) return React.createElement(
    'div',
    { className: 'field-view' },
    text
  );else return React.createElement('div', { className: 'field-view', dangerouslySetInnerHTML: { __html: indexStore.injectIndex(text) } });
}));
export { FieldView };